module.exports = __webpack_public_path__ + "static/media/email_icon.fd99f8e3.png";